import React from 'react';
import { Box, Button, Input } from '@chakra-ui/react';
import PhotoUploadSection from './PhotoUploadSection';
import { USER_TYPES } from '../constants';

interface SocialMediaAndPhotosStepProps {
  instagramHandle: string;
  setInstagramHandle: (value: string) => void;
  tiktokHandle: string;
  setTiktokHandle: (value: string) => void;
  youtubeHandle?: string;
  setYoutubeHandle?: (value: string) => void;
  websiteUrl?: string;
  setWebsiteUrl?: (value: string) => void;
  uploadedPhotos: File[];
  setUploadedPhotos: (photos: File[]) => void;
  photoUrls: string[];
  setPhotoUrls: (urls: string[]) => void;
  maxPhotoSize: number;
  isFormValid: boolean;
  isLoading: boolean;
  onNext: () => void;
  buttonText?: string;
  topPosition?: number;
  showYouTube?: boolean;
  showWebsite?: boolean;
  showButton?: boolean;
}

const SocialMediaAndPhotosStep: React.FC<SocialMediaAndPhotosStepProps> = ({
  instagramHandle,
  setInstagramHandle,
  tiktokHandle,
  setTiktokHandle,
  youtubeHandle = '',
  setYoutubeHandle,
  websiteUrl = '',
  setWebsiteUrl,
  uploadedPhotos,
  setUploadedPhotos,
  photoUrls,
  setPhotoUrls,
  maxPhotoSize,
  isFormValid,
  isLoading,
  onNext,
  buttonText = "Next",
  topPosition = 231,
  showYouTube = true,
  showWebsite = false,
  showButton = true,
}) => {

  const getPhotoSectionTop = () => {
    let baseTop = topPosition + 200; // 231 + 168 (113*2) = 399
    if (showYouTube || showWebsite) baseTop += 113;
    // if (showWebsite) baseTop += 113;
    return baseTop;
  };

  return (
    <>
      <Box
        position="absolute"
        top={`${topPosition}px`}
        left="0"
      >
        {/* Instagram Field */}
        <Box
          top="0px"
          className="form-container"
        >
          <Box position="relative">
            <Input
              placeholder="@ Instagram"
              value={instagramHandle}
              onChange={(e) => setInstagramHandle(e.target.value)}
              className="input-in-form"
            />
          </Box>
        </Box>

        {/* TikTok Field */}
        <Box
          top="110px"
          className="form-container"
        >
          <Box position="relative">
            <Input
              placeholder="@ TikTok"
              value={tiktokHandle}
              onChange={(e) => setTiktokHandle(e.target.value)}
              className="input-in-form"
            />
          </Box>
        </Box>

        {/* YouTube Field - Only for Influencers */}
        {showYouTube && (
          <Box
            top="220px"
            className="form-container"
          >
            <Box position="relative">
              <Input
                placeholder="@ YouTube"
                value={youtubeHandle}
                onChange={(e) => setYoutubeHandle?.(e.target.value)}
                className="input-in-form"
              />
            </Box>
          </Box>
        )}

        {/* Website Field - Only for Business */}
        {showWebsite && (
          <Box
            top="220px"
            className="form-container"
          >
            <Box position="relative">
              <Input
                placeholder="Website"
                value={websiteUrl}
                onChange={(e) => setWebsiteUrl?.(e.target.value)}
                className="input-in-form"
              />
            </Box>
          </Box>
        )}
      </Box>

      {/* Photo Upload Section */}
      <Box
        position="absolute"
        top={`${getPhotoSectionTop()}px`}
        left="22px"
        width="332px"
        marginTop="20px"
      >
        <PhotoUploadSection
          uploadedPhotos={uploadedPhotos}
          setUploadedPhotos={setUploadedPhotos}
          photoUrls={photoUrls}
          setPhotoUrls={setPhotoUrls}
          maxPhotoSize={maxPhotoSize}
          title={showWebsite
            ? "Make an impression with your business - upload the best photos!"
            : "Make an impression with your photos, upload your best shots!"
          }
          emptyStateTitle="Upload photos"
          emptyStateSubtitle="Upload at least 3 photos"
          buttonText="Add more photos"
          showTips={true}
          tipsContext={showWebsite ? USER_TYPES.BUSINESS : USER_TYPES.INFLUENCER}
        />
      </Box>

      {/* Next/Complete Button */}
      {showButton && (
        <Box
          className='button-big-container'        
        >
          <Button
            width="100%"
            height="52px"
            className="button-big"
            onClick={onNext}
            isLoading={isLoading}
            loadingText="Loading..."
            isDisabled={!isFormValid}          
          >
            {buttonText}
          </Button>
        </Box>
      )}
    </>
  );
};

export default SocialMediaAndPhotosStep;
